(function ($) {
    /**
     * Test lesson form controller prototype
     *
     * @type {*[]}
     */
    var tlController = function () {
        return ['$scope', '$http', '$window', function ($scope, $http, $window) {
            $scope.form = TL_FORM;
            var region = getProfileProperty('region');

            // Если в GET-параметре задан id курса, достаем его (с проверкой наличия в массиве курсов текущей формы)
            var predefinedCourse = getPredefinedCourse(Object.keys(getCoursesById($scope.form.courses)));
            if (!predefinedCourse) {
                if ($scope.form.init && $scope.form.init.course) {
                    predefinedCourse = $scope.form.init.course;
                }
            }
            /* Loading flag */
            $scope.isLoading = false;
            $scope.captchaPagesObj = { error:1, data:[] };

            $scope.fields = {
                course: predefinedCourse,
                name: getProfileProperty('name'),
                second_name: getProfileProperty('second_name'),
                last_name: getProfileProperty('last_name'),
                email: getProfileProperty('email'),
                phone: getProfileProperty('phone'),
                region: region === null ? '' : region,
                agree: true,
                online: $scope.form.online
            };

            /**
             * @todo move to some other file. dup code
             * @type {Object}
             */
            var groupsDirty = {};

            var watchDirtyFields = [
                'shipmentType',
                'agree'
            ];
            /**
             * Функция получения массива страниц с проверкой капчи
             * todo: дублируется в order.js & tl.js, но разные $scope
             */
            $scope.getCaptchaPages = function () {
                $http.get('/orders/get-captcha-pages')
                    .success(function (data) {
                        if (data.captchaPages instanceof Array) {
                            $scope.captchaPagesObj.data = data.captchaPages;
                            $scope.captchaPagesObj.error = 0;
                        }
                    });
            };
            $scope.getCaptchaPages(); // сразу и запрашиваем, пока пользователь заполняет форму

            /*
             * @todo move to some other file. dup code
             */
            $scope.$watchGroup(watchDirtyFields.map(function (item) {
                return 'fields.' + item;
            }), function (groups) {
                for (var i in groups) {
                    if (groups[i]) {
                        groupsDirty[watchDirtyFields[i]] = true;
                    }
                }
            });

            /*
             * @todo move to some other file. dup code
             */
            function getProfileProperty(field) {
                var profile = $scope.form.profile;

                return profile && profile[field] ? profile[field] : null;
            }

            $scope.groupValidationClass = function (fieldName) {
                var control = $scope.tlForm[fieldName];

                return {
                    'ng-invalid': control.$invalid,
                    'ng-dirty': groupsDirty[fieldName]
                };
            };

            $scope.submitErrorList = [];

            $scope.submitErrors = function () {
                return $scope.submitErrorList.join('<br>');
            };


            function setError(text) {
                if (!text) {
                    text = 'Перед отправкой заявки необходимо правильно заполнить все поля';
                }
                $scope.isLoading = false;
                $scope.submitErrorList = [text];
                $scope.$emit('submitErrorEvent');

                $('#default-new-downloadTl').popover({
                    container: '.common-form__submit-container',
                    content: $scope.submitErrorList.join('<br>'),
                    delay: { "show": 500, "hide": 100 },
                    placement: 'top',
                    trigger: 'focus click',
                    title: 'Внимание!'
                }).popover('enable').popover('show').popover('disable');
            }

            // отправка формы
            $scope.submit = function () {

                $scope.isLoading = true;



                if (!$scope.tlForm.$valid) {
                    setError();
                    return;
                }

                // проверяем тип ФИО - одно поле или несколько полей если одно разбиваем на несколько
                if (!$scope.fields.last_name) {
                    var name = $scope.fields.name.split(' ');
                    if (name.length > 1) {
                        $scope.fields.name = name[0];
                        if (name.length === 2) {
                            $scope.fields.last_name = name[1];
                        } else {
                            $scope.fields.second_name = name[1];
                            $scope.fields.last_name = name[2];
                        }
                    }
                }

                // Проверяем есть ли кука партнерская и совпадает ли рекл
                var partner;
                if (typeof App.cookie.get('partners_lead_visit') !== 'undefined'
                    && App.cookie.get('channel_code') == JSON.parse(App.cookie.get('partners_lead_visit')).recl
                ) {
                    partner = App.newpartners.getIdentifyPostBack('tl');
                }

                var postBack = [];
                if (partner) {
                    postBack = partner.extParams;
                }


                var postData = {
                    Profiles: {
                        name: $scope.fields.name,
                        second_name: $scope.fields.second_name,
                        last_name: $scope.fields.last_name,
                        phone: $scope.fields.phone,
                        email: $scope.fields.email,
                        region: $scope.fields.region
                    },
                    TestLessons: {
                        courses_id: $scope.fields.course,
                        channel_advert: $scope.form.channelCode,
                        url_parameters: (postBack.uniq && postBack.chan) ? JSON.stringify($.extend({}, JSON.parse(document.getElementById('urlParameters').value), {'PartnerParams' : App.cookie.get('partners_lead_visit')})) : document.getElementById('urlParameters').value,
                        online: $scope.form.online
                    },
                    ExtParams: postBack ? postBack : []
                };

                // Обработка капчи
                if ($scope.captchaPagesObj.error) {
                    setError('При обработке формы произошла ошибка. Попробуйте обновить страницу или обратитесь в службу поддержки ЕШКО.');
                    return;
                }
                var captcha = null;

                if ($scope.captchaPagesObj.data.indexOf(location.pathname.split('/').pop()) !== -1) {
                    captcha = !window.grecaptchaToken ? window.grecaptcha.getResponse() : window.grecaptchaToken;
                    if (captcha === '') {
                        setError('Пожалуйста, выберите "Я не робот"');
                        grecaptcha.reset();
                        return;
                    }
                    postData.captcha = captcha;
                }

                // редирект на страницу спасибо
                function redirect() {
                    $window.location.href = $scope.form.online
                        ? $scope.form.onlineRedirectUrl
                        : $scope.form.emailRedirectUrl;
                }

                // SEND to our server
                $http.post(
                    $scope.form.url,
                    postData
                ).then(function (data) {    // successCallback
                        data = data.data;
                        //произошла ошибка на бекенде (не верные данные формы или еще че)
                        if (!(data.errors instanceof Array) || data.errors.length !== 0) {
                            //сбрасываем капчу т.к. 1 раз уже отправка была
                            if (captcha) {
                                grecaptcha.reset();
                            }
                            setError('Произошла ошибка, попробуйте еще раз немного позже. Если ошибка повторяется, просим Вас прислать скриншот на info@escc.ru');
                            return;
                        }
                        // ставим/обновляем куку с источником tl
                        App.cookie.set('tl_source', document.location.pathname, {path:'/', expires: 7*24*60*60});
                        // подтверждение заказа (пиксели партнеров) если нужно
                        if (partner && partner.hasOwnProperty('orderConfirm') && typeof partner.orderConfirm === "function") {
                            var params = Object.assign(partner.extParams, data, postData);
                            var promise = partner.orderConfirm(params);
                            promise.then(function () {
                                // Эти блоки try-catch исключительно для отправки данных о заказах партнеру ГдеСлон
                                try {
                                    var gdeSlonPromise = App.newpartners.processGdeSlon(postData.Profiles.email);
                                    gdeSlonPromise.then(function () {
                                        redirect();
                                    });
                                } catch (e) {
                                    console.log('Something wrong with processGdeSlon()');
                                    redirect();
                                }
                            });
                        } else {
                            try {
                                var gdeSlonPromise = App.newpartners.processGdeSlon(postData.Profiles.email);
                                gdeSlonPromise.then(function () {
                                    redirect();
                                });
                            } catch (e) {
                                console.log('Something wrong with processGdeSlon()');
                                redirect();
                            }
                        }
                    },
                    //ошибка ответа сервера
                    function (data) {   //  errorCallback
                        //сбрасываем капчу т.к. 1 раз уже отправка была
                        if (captcha) {
                            grecaptcha.reset();

                        }
                        setError('Ошибка: ' + data.statusText + '. Попробуйте еще раз немного позже. Если ошибка повторяется, просим Вас прислать скриншот на info@escc.ru');
                    }
                );
            }
        }];
    };

    // Если на форме есть виджет, но нет корневой директивы ангуляра, значит скорее всего этих виджетов на форме несколько.
    // Присваиваем её в боди
    if ($("form[name=tlForm]").length > 0 && $("[data-ng-app=tl]").length == 0) {
        $("body").attr('data-ng-app', 'tl');
    }
    var m = angular.module('tl', ['utils']);
    m.controller('TlFormCtrl', tlController());
})(jQuery);
